import { useState, useEffect } from 'react';
import { error, THD_BRAND_NAME, FEATURED_BRANDS } from '../utils/consts';
import { fetchJson, getJsonPath } from '../utils/util';

export const useGiftCards = (props) => {
  const { brand } = props;
  const [giftCards, setGiftCards] = useState([]);
  const [errorMsg, setErrorMsg] = useState(null);
  const [loading, setLoading] = useState(false);
  const { firstPartyJsonUrl, thirdPartyJsonUrl, getBrandsJsonUrl } = getJsonPath();

  useEffect(() => {
    const fetchGiftCards = async () => {
      let masterData = [];
      try {
        setLoading(true);
        if (brand && brand === FEATURED_BRANDS) {
          masterData = await fetchJson(getBrandsJsonUrl);
        } else if (brand && brand.length && !brand.includes(THD_BRAND_NAME)) {
          masterData = await fetchJson(thirdPartyJsonUrl);
        } else if (brand && brand.length && brand === `${THD_BRAND_NAME} Exclusive`) {
          masterData = await fetchJson(firstPartyJsonUrl);
        } else {
          const masterData1 = await fetchJson(firstPartyJsonUrl);
          const masterData2 = await fetchJson(thirdPartyJsonUrl);
          masterData = masterData1.concat(masterData2);
        }
        setGiftCards(masterData);
        setLoading(false);
      } catch (_error) {
        setLoading(false);
        setErrorMsg(error.technicalError);
      }
    };
    fetchGiftCards();
  }, [brand]);

  return { giftCards, loading, errorMsg };
};
